import React, { useLayoutEffect, useRef, useState } from "react";

const SECTION_LABELS = new Set(["PLACES", "LEASES", "PROJECTS", "REPORTS", "ADMIN"]);

// Observe the rendered navigation, not a slot/portal host: hosts can be empty
// during readiness, and report back links must never count as section tabs.
function hasVisibleSectionTabs(root) {
  return [...root.querySelectorAll(".object-subnav-tabs .object-chrome-tab")].some(tab => {
    for (let node = tab; node && node !== root; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute("aria-hidden") === "true"
        || style.display === "none" || style.visibility === "hidden") return false;
    }
    return true;
  });
}

export function HeaderSectionEyebrow({ label, observeTabs = false, record = false }) {
  const [hasTabs, setHasTabs] = useState(false);
  const eyebrowRef = useRef(null);
  const section = label?.toUpperCase();
  useLayoutEffect(() => {
    const root = observeTabs ? eyebrowRef.current?.parentElement : null;
    if (!root) return;
    const update = () => setHasTabs(hasVisibleSectionTabs(root));
    update();
    const observer = new MutationObserver(update);
    observer.observe(root, { childList: true, subtree: true, attributes: true });
    return () => observer.disconnect();
  }, [observeTabs, section]);
  if (!SECTION_LABELS.has(section)) return null;
  return <span ref={eyebrowRef} className={`one-row-section-label${record ? " one-row-record-section" : ""}${hasTabs ? " one-row-section-with-tabs" : ""}`}
    data-testid="header-section-eyebrow">
    <span>{section}</span>
    {hasTabs && <span className="one-row-section-divider" data-testid="header-section-divider" aria-hidden="true" />}
  </span>;
}
